import React, { useCallback, useState, useEffect, useMemo } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { Modal, notification } from 'antd';
import { Portal } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import moment from "moment";

import { getStorage } from '../../../../../utils/common';
import { ADMIN_DETAILS } from '../../../../../dataProvider/constant';
import DraggableActivityV2Row from './DraggableActivityV2Row';
import AddEditJSA2Activity from './AddEditJSA2Activity';

import styles from "../../JobStyle.module.css";

const JSASection2 = ({ allActivities, change, loading }) => {

  const [activities, setActivities] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(null);

  useEffect(() => {
    setActivities(allActivities.map((x, i) => ({ ...x, edited: x.edited ? x.edited : false, activity_order: i + 1 })));
  }, [allActivities])

  const afterDrop = useCallback(() => {
    change("jsa_section_2.activities", [...activities])
  })

   const user = useMemo(() => {
      const details = JSON.parse(getStorage(ADMIN_DETAILS));
      return details ? details : null
    }, []);
  
    const userName = useMemo(() => {
      let name = null;
      if (user) {
        name = `${user.name} ${user.last_name}`;
      }
      return name;
    }, [user])

  const moveActivities = useCallback((dragIndex, hoverIndex) => {
    setActivities(prevActs => {
      let allActs = [...prevActs];
      let [el] = allActs.splice(dragIndex, 1);
      allActs.splice(hoverIndex, 0, el);
      return allActs.map(({ index, ...x }, i) => ({ ...x, activity_order: i + 1 }));
    });
  });

  const onToggleActive = (index) => {
    let acts = [...activities];
    let changedVal = acts[index].toggled_active === 1 ? 0 : 1;
    const historyObj = {
      status: "Status Changed",
      description: changedVal === 1 ? "Activity marked as active." : "Activity marked as inactive.",
      created_by: user ? user.user_name : null,
      created_by_name: userName,
      created_at: moment.utc().toISOString()
    }
    acts[index].toggled_active = acts[index].toggled_active === 1 ? 0 : 1;
    const allHistory = acts[index].history ? [historyObj, ...acts[index].history] : [historyObj];
    acts[index].history = [...allHistory];
    change("jsa_section_2.activities", [...acts]);
  }

  const onActivitySubmit = (act) => {
    let allActs = [...activities];
    let index = allActs.findIndex(x => x.activity_id === act.activity_id);
    if (index !== -1) {
      allActs[index] = act;
      change("jsa_section_2.activities", [...allActs]);
      notification.success({
        className: "ant-success",
        message: "Activity Updated Successfully.",
        description: "Please save the form to retain the activity."
      })
      setAddModal(false);
    } else {
      allActs.push(act);
      change("jsa_section_2.activities", [...allActs]);
      notification.success({
        className: "ant-success",
        message: "New Activity Added Successfully.",
        description: "Please save the form to retain the activity."
      });
      setAddModal(false);
    }
  }

  const onEditActivity = (index) => {
    setSelectedActivity(activities[index]);
    setAddModal(true);
  }

  const onActivitySave = (activityData) => {

  }

  return (
    <div className="m-1 mb-2">
      <div className="contianer-fluid px-0">
        <div className="row">
          <div className="col-12">
            <DndProvider backend={HTML5Backend}>
              <table className="table table-sm cs-table cs-table-v2" style={{ tableLayout: "fixed", width: "100%" }}>
                <thead>
                  <tr>
                    <th width="40"></th>
                    <th width="50" className="text-center">Step</th>
                    <th>Activity</th>
                    <th>Category</th>
                    <th>Method</th>
                    <th>Created By</th>
                    <th>Edited By</th>
                    <th>Approved By</th>
                    <th width="120">Site Edit</th>
                    <th width="150">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {activities.map((activity, index) => (
                    <DraggableActivityV2Row
                      activity={activity}
                      genId={"jsa_2_gen_id"}
                      change={change}
                      key={`${activity.activity_id}`}
                      index={index}
                      loading={loading}
                      onToggleActive={() => onToggleActive(index)}
                      onEditActivity={() => onEditActivity(index)}
                      afterDrop={afterDrop}
                      moveRow={moveActivities} />
                  ))}
                  {activities.length === 0 ? (
                    <tr>
                      <td colSpan={10} className="text-center" style={{ color: "red" }}>No Activities Available.</td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </DndProvider>
            <div className="mt-3 mb-2 text-right">
              <button type="button" onClick={() => setAddModal(true)} disabled={loading} className={styles.PrimaryButton}>Add New Activity</button>
            </div>
          </div>
        </div>
      </div>
      <Portal container={() => document.getElementById("root")}>
        <div onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
          <Modal
            className="cs-modal-v2"
            centered
            footer={null}
            visible={addModal}
            width="90vw"
            height="90vh"
            onCancel={() => setAddModal(false)}
            afterClose={() => { setSelectedActivity(null) }}
            maskClosable={false}
            bodyStyle={{ paddingRight: "0px", paddingLeft: "0px", maxHeight: "80vh", overflow: "hidden auto" }}
            destroyOnClose={true}
            closeIcon={<div className={styles.ModalCloseIcon}><CloseIcon /></div>}
          >
            {addModal ? (
              <AddEditJSA2Activity onActivitySubmit={onActivitySubmit} selectedActivity={selectedActivity} onClose={() => setAddModal(false)} onSubmit={onActivitySave} />
            ) : null}
          </Modal>
        </div>
      </Portal>
    </div>
  )
}

export default connect((state) => ({
  allActivities: (formValueSelector("job_swms_form"))(state, "jsa_section_2.activities"),
}))(JSASection2);
